import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useReporteSST } from '@/hooks/useReporteSST';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import Footer from '@/components/Footer';
import { ReporteFormatoICA } from '@/components/reportes/ReporteFormatoICA';
import { ExportarReporte } from '@/components/reportes/ExportarReporte';
import logoViable from '@/assets/logo-viabiliza.png';

const ReporteSSTDetalle = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { id } = useParams<{ id: string }>();
  const { loading, datosReporte } = useReporteSST(id);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!datosReporte) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Card className="p-6">
          <p className="text-gray-500">No se encontraron datos para este reporte</p>
          <Button onClick={() => navigate('/reporte-sst')} className="mt-4">
            Volver a la lista
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <img src={logoViable} alt="Logo Viabiliza" className="h-12" />
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Reporte SST - Formato ICA</h1>
                <p className="text-sm text-gray-600">{datosReporte.obligacion.codigo}</p>
              </div>
            </div>
            <div className="flex gap-2">
              <Button variant="outline" onClick={() => navigate('/reporte-sst')}>
                <ArrowLeft className="mr-2 h-4 w-4" />
                Volver
              </Button>
              <Button variant="destructive" onClick={signOut}>
                Cerrar Sesión
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Botones de Exportación */}
        <div className="mb-6">
          <ExportarReporte datos={datosReporte} />
        </div>

        {/* Reporte */}
        <Card className="shadow-lg">
          <ReporteFormatoICA datos={datosReporte} />
        </Card>
      </main>

      <Footer />
    </div>
  );
};

export default ReporteSSTDetalle;
